export default __webpack_public_path__ + "static/media/clear-input.a4af29dc.svg";